function initMap() {
  const event = new CustomEvent("init-map");
  window.dispatchEvent(event);
}

function updateMap() {
  const event = new CustomEvent("update-map");
  window.dispatchEvent(event);
}

window.initMap = initMap;
window.updateMap = updateMap;
